<template>
  <div class="page">
    <b-overlay
      :show="loading"
      variant="light"
      opacity="0.5"
      rounded="false"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <JurisdictionLayout
          :route-from="routeFrom"
          @loading="$event => loading = $event"
          @cancel="
            currentOrganisation && currentOrganisation.id ?
              $router.push({
                name: 'OrganisationDetail',
                params: {
                  id: currentOrganisation.id
                }
              }) :
              { name: 'Organisations'}
          "
          @save-continue="handleSubmit(() => createJurisdiction(true))"
          @save="handleSubmit(createJurisdiction)"
        />
      </ValidationObserver>
    </b-overlay>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { ErrorService } from '@/services/error-service.js';

import JurisdictionLayout from '@/app/jurisdiction/layouts/JurisdictionLayout.vue';

import { ValidationObserver } from 'vee-validate';

export default {
  name: 'NewJurisdiction',

  components: {
    JurisdictionLayout,
    ValidationObserver
  },

  data() {
    return {
      loading: false,
      routeFrom: null
    };
  },

  computed: {
    ...mapState('organisations', [
      'currentOrganisation'
    ]),
    ...mapState('jurisdiction', [
      'currentJurisdiction'
    ])
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.routeFrom = from;
    });
  },

  async created () {
    this.RESET_SELECTED_MUNICIPALITIES();
    await this.GET_MUNICIPALITIES();
  },

  methods: {
    ...mapMutations('municipalities', [
      'RESET_SELECTED_MUNICIPALITIES'
    ]),
    ...mapActions('municipalities', [
      'GET_MUNICIPALITIES'
    ]),
    ...mapActions('jurisdiction', [
      'CREATE_JURISDICTION'
    ]),

    async createJurisdiction(keepEditing = false) {
      try {
        this.loading = true;
        await this.CREATE_JURISDICTION();
        this.loading = false;
        if (keepEditing) {
          this.$router.push({
            name: 'JurisdictionDetail',
            params: {
              id: this.currentJurisdiction.id
            }
          });
        } else {
          this.$router.push({
            name: 'JurisdictionsList'
          });
        }
      } catch (err) {
        console.error(err);
        ErrorService.onError(err);
        this.loading = false;
      }
    }
  }
};
</script>